import { useState } from 'react';
import './forgotPassword.scss';

import apiRequest from '../../lib/apiRequest';

function ForgotPassword() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    const formData = new FormData(e.target);

    const email = formData.get('email');

    try {
      const res = await apiRequest.post('/auth/reset-password', {
        email,
      });

      if (res) {
        setError(
          'An email with instructions for restoring access\n has been sent to you.\n Please check your mailbox!'
        );
      }
    } catch (err) {
      setError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="login">
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <h1>Forgot password?</h1>
          <input
            name="email"
            required
            type="email"
            placeholder="Enter your Email address"
          />
          <button disabled={isLoading}>Send</button>
          {error && <span>{error}</span>}
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
